"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_multi_clamp_1 = __importDefault(require("react-multi-clamp"));
const Layout_1 = require("../Layout");
const Paragraph = ({ text, clamp }) => {
    return (react_1.default.createElement(Layout_1.Flex, { title: text },
        react_1.default.createElement(react_multi_clamp_1.default, { clamp: clamp, splitByWords: true }, text)));
};
exports.default = Paragraph;
//# sourceMappingURL=Paragraph.js.map